<script setup async>
import { ref, inject, onMounted, computed, watchEffect, watch } from "vue";
import { checkAppUserAgent, jsbridge, setupWebViewJavascriptBridge } from "../utils";
const { curFlycard, curFlycardIndex, curCategory } = inject("useDataHook");
const { playerStatus, playerInit, togglePlayerStatus, howlerList } = inject(
  "usePlayerHook"
);

import { from } from "rxjs";
import { lastValueFrom } from "rxjs/operators";

let isAppEnv = ref(inject("isAppEnv"));
console.log(isAppEnv.value);

import { useRoute, useRouter } from "vue-router";
const $route = useRoute();

const praiseCount = ref(0);
const isPraise = ref(0);

const addPraise = () => {
  jsbridge("addPraise", appParam.value);
};
const getPraiseCount = async () => {
  if (checkAppUserAgent()) {
    console.log("getPraiseCount");

    await jsbridge("getPraiseCount", appParam.value);
  }

  // fetchPraiseCount()
};
const backHomePage = () => {
  playerStatus.value = 0;
  // jsbridge("backHome", "");
  window.open('http://inanshan.sznews.com/?from=flycard')
};

const showShareTip = ref(false);
const setShare = () => {
  if (isAppEnv.value) {
    jsbridge("share", appParam.value);
  } else {
    console.log(window.location.href);

    showShareTip.value = true;
  }
};

const setComment = () => {
  jsbridge("comment", appParam.value);
};

const updatePraiseCount = (e) => {
  window.updatePraiseCount = (e) => {
    console.log(e);
  };
  console.log("updatePraiseCount === ", e);
};

const appParam = computed(() => {
  let flycardInfo = curFlycard.value;
  flycardInfo["mediaId"] = curCategory.value["id"];
  let param = {
    news: curFlycard.value,
  };
  param = `${JSON.stringify(param)}`;
  return param;
});

const setPlayer = async () => {
  if (curFlycard.value && curFlycard.value.content == '<div></div>') {
    return false
  }
  await playerInit(curFlycard.value);
};

const playerStatusBtnOnClick = (oldStatus) => {
  if (curFlycard.value && curFlycard.value.content == '<div></div>') {
    return false
  }
  togglePlayerStatus(curFlycard.value, oldStatus);
};

const openApp = () => {
  window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.sznews";
};

let init = ref(false);
watchEffect(async () => {
  if (curCategory.value && !init.value) {
    if (!window.updatePraiseCount) {
      setupWebViewJavascriptBridge((bridge) => {
        bridge.registerHandler("updatePraiseCount", (data, fn) => {
          console.log("updatePraiseCount === ", data);
          data = JSON.parse(data);
          praiseCount.value = data.praiseCount;
          isPraise.value = data.isPraise;
          fn && fn();
        });
      });
      window.updatePraiseCount = (data) => {
        console.log("updatePraiseCount === ", data);
        praiseCount.value = data.praiseCount;
        isPraise.value = data.isPraise;
      };
    }

    setPlayer();
    await getPraiseCount();
    init.value = true;
  }
});

let t = null;
watch($route, async (to, from) => {
  if (!t) {
    t = setTimeout(async () => {
      setPlayer();
      await getPraiseCount();
      t = null;
    }, 300);
  } else {
    if (praiseCount.value) {
      praiseCount.value = 0;
      isPraise.value = "0";
    }
  }
  playerStatus.value = 0;
  isPraise.value = "0";
});
</script>

<template>
  <van-overlay :show="showShareTip" @click="showShareTip = false" z-index="121">
    <div class="wrapper">
      <img src="../assets/sharebg.png" class="sharebg" />
    </div>
  </van-overlay>
  <div class="tabbar">
    <!-- <p class="praise-count" v-if="praiseCount > 0">{{ praiseCount }}</p> -->
    <!-- <div class="tabbarItem" @click="addPraise">
      <img v-show="isPraise=='0'" src="../assets/card_btn_love.png" />
      <img v-show="isPraise=='1'" src="../assets/card_btn_love_pre.png" />
    </div>-->
    <!-- <div class="tabbarItem" @click="setComment">
      <img src="../assets/card_btn_comment.png" />
    </div>-->
    <div class="tabbarItem" @click="setShare">
      <img src="../assets/card_btn_share.png" />
    </div>
    <div
      class="tabbarItem playerStatus"
      :class="curFlycard && curFlycard.content === '<div></div>' ? 'cannotplay' : ''"
    >
      <img
        src="../assets/read.gif"
        v-if="curCategory && curFlycard && playerStatus === 2"
        @click="playerStatusBtnOnClick(2)"
      />
      <img
        src="../assets/play.png"
        v-if="curCategory && curFlycard && playerStatus === 0 && curFlycard.rtype == '6'"
        @click="playerStatusBtnOnClick(0)"
      />
      <img
        src="../assets/play.png"
        v-if="curCategory && curFlycard && playerStatus === 1"
        @click="playerStatusBtnOnClick(1)"
      />
      <img
        src="../assets/voice.png"
        v-if="curCategory && curFlycard && playerStatus === 0 && curFlycard.rtype != '6'"
        @click="playerStatusBtnOnClick(0)"
      />
      <img src="../assets/voice.png" v-if="!curCategory || !curFlycard" />
    </div>

    <div class="tabbarItem" @click="backHomePage">
      <img src="../assets/card_btn_home.png" />
    </div>
  </div>

  <!-- <div class="tabbar" :class="!isAppEnv ? 'outer' : ''" v-if="!isAppEnv">
    <div>
      <div class="tabbarItem playerStatus">
        <img
          src="../assets/read.gif"
          v-if="curCategory && curFlycard && playerStatus === 2"
          @click="playerStatusBtnOnClick(2)"
        />
        <img
          src="../assets/play.png"
          v-if="
            curCategory && curFlycard && playerStatus === 0 && curFlycard.rtype == '6'
          "
          @click="playerStatusBtnOnClick(0)"
        />
        <img
          src="../assets/play.png"
          v-if="curCategory && curFlycard && playerStatus === 1"
          @click="playerStatusBtnOnClick(1)"
        />
        <img
          src="../assets/voice.png"
          v-if="
            curCategory && curFlycard && playerStatus === 0 && curFlycard.rtype != '6'
          "
          @click="playerStatusBtnOnClick(0)"
        />
        <img src="../assets/voice.png" v-if="!curCategory || !curFlycard" />
      </div>
      <div class="openApp tabbarItem" @click="openApp">
        <p>打开见圳APP体验飞卡</p>
      </div>
    </div>
    <div class="tabbarItem" @click="setShare">
      <img src="../assets/card_btn_share.png" />
    </div>
  </div>-->
</template>

<style lang="scss" scoped>
.tabbar {
  bottom: $--tabbar-space;
  height: $--tabbar-height;
  padding: 0 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &.outer {
    > div {
      display: flex;
      align-items: center;
    }
  }

  .praise-count {
    position: absolute;
    background: $--theme-color;
    color: #fff;
    font-size: 14px;
    height: min-content;
    line-height: 1;
    padding: 2px 20px;
    border-radius: 10px;
    top: 10px;
    left: 116px;
    z-index: 996;
  }

  .tabbarItem {
    width: 0.72 * $--tabbar-height;
    height: 0.72 * $--tabbar-height;
    position: relative;

    &.playerStatus {
      width: $--tabbar-height;
      height: $--tabbar-height;
      background: url("../assets/tabbarItemBg_0.png") no-repeat center / contain;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 70px;
      img {
        width: 54%;
      }

      &.cannotplay {
        background: url("../assets/tabbarItemBg_1.png") no-repeat center /
          contain;
      }
    }

    &.openApp {
      width: 400px;
      height: 72px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: url("../assets/card_btn_sharebg.png") no-repeat center /
        contain;
      font-size: 28px;
      color: #fff;
    }
  }
}
</style>
